import { Auth } from 'aws-amplify'
import * as Sentry from '@sentry/react'

export const userLogout = () => {
  Sentry.setUser(null)
  Auth.signOut()
}